import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import { apiEndpoints, orchestratorFetcher } from '../lib';
import { GetCurrentStepResponseDataT } from '../orchestrator/loan-application/flow/get-current-step/types';
import { OrchestratorResponseDataT } from '../orchestrator/shared/types';

export const useCurrentStep = (flowId: string) => {
  const {
    data,
    error,
    isLoading,
  } = useSWRImmutable<OrchestratorResponseDataT<GetCurrentStepResponseDataT>, AxiosError>(
    flowId ? apiEndpoints.currentStep(flowId) : null,
    orchestratorFetcher,
  );

  return {
    error,
    isLoading,
    response: data,
  };
};
